export default function PotCalendarScript() {
    // Check if the module exists before doing anything
    const PotCalendarExists = !!document.querySelector('.pot-calendar-app');

    // If the module exists, do whatever we need to
    if (PotCalendarExists) {
        // Your code here
        console.log('pot calendar');

        const calendarEls = document.querySelectorAll('.pot-calendar-app');

        calendarEls.forEach((calendarEl) => {
            const { calendarDisplay } = calendarEl.dataset;
            console.log('display as', calendarDisplay);
            const newCurrentYear = new Date().getFullYear();
            const newCurrentMonth = new Date().getMonth();
            console.log(
                'current year and month',
                newCurrentYear,
                newCurrentMonth
            );

            const year = calendarEl.dataset.calendarYear;
            const months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];

            function CalendarControl(calYear, month) { // eslint-disable-line
                const calendar = new Date(calYear, month, 1);
                const calendarControl = {
                    localDate: new Date(),
                    prevMonthLastDate: null,
                    calWeekDays: [
                        'Sun',
                        'Mon',
                        'Tue',
                        'Wed',
                        'Thu',
                        'Fri',
                        'Sat',
                    ],
                    calMonthName: months,
                    daysInMonth(month, calYear) { // eslint-disable-line
                        return new Date(calYear, month, 0).getDate();
                    },
                    firstDay() {
                        return new Date(
                            calendar.getFullYear(),
                            calendar.getMonth(),
                            1
                        );
                    },
                    lastDay() {
                        return new Date(
                            calendar.getFullYear(),
                            calendar.getMonth() + 1,
                            0
                        );
                    },
                    firstDayNumber() {
                        return calendarControl.firstDay().getDay() + 1;
                    },
                    lastDayNumber() {
                        return calendarControl.lastDay().getDay() + 1;
                    },
                    getPreviousMonthLastDate() {
                        const lastDate = new Date(
                            calendar.getFullYear(),
                            calendar.getMonth(),
                            0
                        ).getDate();
                        return lastDate;
                    },
                    displayYear() {
                        const yearLabel = calendarEl.querySelector(
                            '.pot-calendar-year-label'
                        );
                        yearLabel.innerHTML = calendar.getFullYear();
                    },
                    displayMonth() {
                        const monthLabel = calendarEl.querySelector(
                            '.pot-calendar-month-label'
                        );
                        monthLabel.innerHTML =
                            calendarControl.calMonthName[calendar.getMonth()];
                    },
                    selectDate(e) {
                        console.log(
                            `${e.target.textContent} ${
                                calendarControl.calMonthName[
                                    calendar.getMonth()
                                ]
                            } ${calendar.getFullYear()}`
                        );
                    },
                    plotSelectors() {
                        const markup = `<div class="pot-calendar" data-month="${month}"><div class="pot-calendar-inner"><div class="pot-calendar-controls">
                        <div class="pot-calendar-year-month">
                        <div class="pot-calendar-month-label"></div>
                        <div class="pot-calendar-year-label"></div>
                        </div>
                        </div>
                        <div class="pot-calendar-body"></div></div></div>`;

                        calendarEl.insertAdjacentHTML('afterbegin', markup);
                    },
                    plotDayNames() {
                        for (
                            let i = 0;
                            i < calendarControl.calWeekDays.length;
                            i++
                        ) {
                            calendarEl.querySelector( // eslint-disable-line
                                '.pot-calendar-body'
                            ).innerHTML += `<div class="day-name">${calendarControl.calWeekDays[i]}</div>`;
                        }
                    },
                    plotDates() {
                        calendarEl.querySelector( // eslint-disable-line
                            '.pot-calendar-body'
                        ).innerHTML = '';
                        calendarControl.plotDayNames();
                        calendarControl.displayMonth();
                        calendarControl.displayYear();
                        let count = 1;
                        let prevDateCount = 0;

                        calendarControl.prevMonthLastDate =
                            calendarControl.getPreviousMonthLastDate();
                        const prevMonthDatesArray = [];
                        const calendarDays = calendarControl.daysInMonth(
                            calendar.getMonth() + 1,
                            calendar.getFullYear()
                        );
                        // dates of current month
                        for (let i = 1; i < calendarDays; i++) {
                            if (i < calendarControl.firstDayNumber()) {
                                prevDateCount += 1;
                                calendarEl.querySelector( // eslint-disable-line
                                    '.pot-calendar-body'
                                ).innerHTML += `<div class="prev-dates"></div>`;
                                prevMonthDatesArray.push(
                                    calendarControl.prevMonthLastDate--  // eslint-disable-line
                                );
                            } else {
                                calendarEl.querySelector( // eslint-disable-line
                                    '.pot-calendar-body'
                                ).innerHTML += `<div class="number-item" data-num=${count}><span class="dateNumber">${count++}</span></div>`; // eslint-disable-line
                            }
                        }

                        // remove the entire rows of previous dates
                        if (prevDateCount === 6) {
                            const prevDatesEls = calendarEl.querySelectorAll(
                                `[data-month="${month}"] .prev-dates`
                            );
                            prevDatesEls.forEach(
                                (el) => (el.style.display = 'none') // eslint-disable-line
                            );
                        }

                        // remaining dates after month dates
                        for (let j = 0; j < prevDateCount + 1; j++) {
                            calendarEl.querySelector( // eslint-disable-line
                                '.pot-calendar-body'
                            ).innerHTML += `<div class="number-item" data-num=${count}><span class="dateNumber">${count++}</span></div>`; // eslint-disable-line
                        }
                        calendarControl.highlightToday();
                        calendarControl.plotPrevMonthDates(prevMonthDatesArray);
                        calendarControl.plotNextMonthDates();
                    },
                    attachEvents() {
                        const dateNumber =
                            calendarEl.querySelectorAll('.dateNumber');
                        for (let i = 0; i < dateNumber.length; i++) {
                            dateNumber[i].addEventListener(
                                'click',
                                calendarControl.selectDate,
                                false
                            );
                        }
                    },
                    highlightToday() {
                        const currentMonth =
                            calendarControl.localDate.getMonth() + 1;
                        const changedMonth = calendar.getMonth() + 1;
                        const currentYear =
                            calendarControl.localDate.getFullYear();
                        const changedYear = calendar.getFullYear();
                        if (
                            currentYear === changedYear &&
                            currentMonth === changedMonth &&
                            calendarEl.querySelectorAll('.number-item')
                        ) {
                            calendarEl
                                .querySelectorAll('.number-item')
                                [
                                    calendarControl.localDate.getDate() - 1
                                ].classList.add('pot-calendar-today');
                        }
                    },
                    plotPrevMonthDates(dates) {
                        dates.reverse();
                        for (let i = 0; i < dates.length; i++) {
                            if (calendarEl.querySelectorAll('.prev-dates')) { // eslint-disable-line
                                calendarEl.querySelectorAll('.prev-dates')[ // eslint-disable-line
                                    i
                                ].textContent = dates[i];
                            }
                        }
                    },
                    plotNextMonthDates() {
                        const childElemCount =
                            calendarEl.querySelector(
                                '.pot-calendar-body'
                            ).childElementCount;
                        // 7 lines
                        if (childElemCount > 42) {
                            const diff = 49 - childElemCount;
                            calendarControl.loopThroughNextDays(diff);
                        }

                        // 6 lines
                        if (childElemCount > 35 && childElemCount <= 42) {
                            const diff = 42 - childElemCount;
                            calendarControl.loopThroughNextDays(diff);
                        }
                    },
                    loopThroughNextDays(count) {
                        if (count > 0) {
                            for (let i = 1; i <= count; i++) {
                                calendarEl.querySelector( // eslint-disable-line
                                    '.pot-calendar-body'
                                ).innerHTML += `<div class="next-dates">${i}</div>`;
                            }
                        }

                        // remove the entire rows of next dates
                        if (count === 6) {
                            const nextDatesEls = calendarEl.querySelectorAll(
                                `[data-month="${month}"] .next-dates`
                            );
                            nextDatesEls.forEach(
                                (el) => (el.style.display = 'none') // eslint-disable-line
                            );
                        }
                    },
                    attachEventsOnNextPrev() {
                        calendarControl.plotDates();
                        calendarControl.attachEvents();
                    },
                    init() {
                        calendarControl.plotSelectors();
                        calendarControl.plotDates();
                        calendarControl.attachEvents();
                    },
                };
                calendarControl.init();
            }

            // Build the calendar as a 'year' display or 'current year and month' display
            if (calendarDisplay === 'year') {
                for (let i = 11; i >= 0; i--) {
                    const calendarApp = CalendarControl(year, i);  // eslint-disable-line
                }
            } else if (calendarDisplay === 'month') {
                const calendarApp = CalendarControl(newCurrentYear, newCurrentMonth);  // eslint-disable-line
            }

            const datesUrl = calendarEl.dataset.feed;
            console.log(datesUrl);

            const getDates = async () => {
                const res = await fetch(datesUrl);
                const data = res.json();
                return data;
            };

            getDates().then((data) => {
                console.log(data);
                data.forEach((item) => {
                    const targetYear = new Date(item.date).getFullYear();
                    if (targetYear === +year) {
                        const day = new Date(item.date).getDate();
                        const month = new Date(item.date).getMonth();
                        const calDayEl = calendarEl.querySelector(
                            `.pot-calendar[data-month="${month}"] .number-item[data-num="${day}"]`
                        );

                        if (calDayEl) {
                            calDayEl.classList.add('number-active');
                            calDayEl.innerHTML = `<a href="${item.link}">${day}</a>`;
                        }
                    }
                });
            });

            // const data = [
            //     {
            //         assetID: '11422',
            //         date: 'March 11, 2022',
            //         link: 'https://pot-web.squiz.cloud/sandbox-site/calendar/2022/legislative-council-19-march-2019',
            //     },
            //     {
            //         assetID: '11445',
            //         date: 'May 03, 2022',
            //         link: 'https://pot-web.squiz.cloud/sandbox-site/calendar/2022/legislative-council-03-may-2022',
            //     },
            //     {
            //         assetID: '11449',
            //         date: 'June 07, 2021',
            //         link: 'https://pot-web.squiz.cloud/sandbox-site/calendar/2022/legislative-council-07-june-2021',
            //     },
            //     {
            //         assetID: "11905",
            //         name: "Test 24th January 2023",
            //         date: "January 24, 2023",
            //         link: "https://pot-web.squiz.cloud/legislative-council/chamber-proceedings/calendars/2023/january/test-24th-january-2023"
            //     },
            //     {
            //         assetID: "60211",
            //         name: "Test 23rd February 2023",
            //         date: "February 23, 2023",
            //         link: "https://pot-web.squiz.cloud/legislative-council/chamber-proceedings/calendars/2023/february/test-23rd-february-2023"
            //     }

            // ];

            // data.forEach((item) => {
            //     const targetYear = new Date(item.date).getFullYear();
            //     if (targetYear === +year) {
            //         const day = new Date(item.date).getDate();
            //         const month = new Date(item.date).getMonth();
            //         const calDayEl = document.querySelector(
            //             `.pot-calendar[data-month="${month}"] .number-item[data-num="${day}"]`
            //         );

            //         if (calDayEl) {
            //             calDayEl.classList.add('number-active');
            //             calDayEl.innerHTML = `<a href="${item.link}" target="_blank">${day}</a>`;
            //         }
            //     }
            // });
        });
    }
}

PotCalendarScript();
